import { Link } from "react-router";
import styles from "./Header.module.css";

export function Header() {
  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <Link to="/" className={styles.logo}>
          <TotemIcon />
          <span className={styles.logoText}>Totemfeed</span>
        </Link>

        <nav className={styles.nav}>
          <Link to="/about" className={styles.navLink}>
            What is this?
          </Link>
          <Link to="/archive" className={styles.navLink}>
            Previous Totems
          </Link>
        </nav>
      </div>
    </header>
  );
}

function TotemIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.logoIcon}
    >
      {/* Stylized totem head with wings */}
      <path
        d="M14 2L16 6L20 4L18 8L22 10L18 12L20 16L14 14L8 16L10 12L6 10L10 8L8 4L12 6L14 2Z"
        fill="currentColor"
      />
      <circle cx="11" cy="10" r="1.5" fill="var(--color-bg-primary)" />
      <circle cx="17" cy="10" r="1.5" fill="var(--color-bg-primary)" />
      <rect x="12" y="16" width="4" height="10" rx="1" fill="currentColor" />
    </svg>
  );
}
